import { View } from "@/components/ui/view";
import { CheckIcon } from "@/components/ui/icon";
import { Checkbox, CheckboxIndicator, CheckboxIcon } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Progress, ProgressFilledTrack } from "@/components/ui/progress";
import { HStack } from "@/components/ui/hstack";
import { Box } from "@/components/ui/box";
import i18n from 'i18n-js';
import React, { useState } from 'react';
import { useWindowDimensions } from 'react-native';
import { TouchableWithoutFeedback, Gesture, GestureDetector } from 'react-native-gesture-handler';
import Animated, { runOnJS, useAnimatedStyle, useSharedValue, withSpring } from 'react-native-reanimated';
import { useSelector } from 'react-redux';
import ImageSynced from '../media/ImageSynced';
import TimerDisplay from './TimerDisplay';
import BasicElement from '../basic/BasicElement';
import { switchScreen } from '../../hooks/navigate';
import inaLogo from '../../assets/icons/icon_blue_rounded_512x512.png'
import avatar1 from '../../assets/images/avatar_mit_background.png'
import { IconM, IconMC } from '../media/IconsV2';
import shared from "../../assets/images/shareButton.png"

const ButtonElement = ({ task, showProgress, showTimer, onPress, disabled, greyout, selected, onSelect, icon, replaceAvatar, isDone, info, changed, context }) => {
    const imgLoad = useSelector((state) => state.images.load)
    const user = useSelector((state) => state.user)
    const [avatar, setAvatar] = useState(replaceAvatar ? replaceAvatar : task?.owned && task?.shared ? shared : task?.simulatorPreview || task?.id.length < 2 ? inaLogo : task?.contact || (user.userImage ? (user.avatar || user.id) : avatar1))
    // console.log('AVATAR', task.title, avatar, avatar1, replaceAvatar, user?.avatar, user?.userImage, task?.contact)

    const [isActive, setIsActive] = useState(false)

    const onPressLocal = () => {
        onPress(task.id, context)
    }

    const onSelectLocal = (e) => {
        onSelect(task.id, e)
    }

    const getRefresh = () => {
        return avatar == user.id ? user.updated : imgLoad[avatar]?.duration
    }

    return task ? (
        <View>
            <Button onPress={onPressLocal} disabled={disabled} className={` ${(showProgress && task && task.step != -1) ? "mt-1" : "mt-0"} h-[80px] p-0 px-3 bg-secondary-50 active:bg-primary-300 `}>
                <BasicElement
                    media={task.media[0]}
                    overlay={task?.overlays?.[task.media[0]]}
                    prefix={changed ? i18n.t('global.new') : ''}
                    title={task.title}
                    text={info ? info : task.step == -1 ? i18n.t('showWorkflowScreen.numberOfSteps', { steps: task.steps.length }) : i18n.t('showWorkflowScreen.stepProgress', { step: task.step + 1, maxSteps: task.steps.length })}
                    disabled={greyout}
                    mark1={changed}
                >
                    {isDone == undefined ?
                        onSelect == undefined ?
                            avatar &&
                            <Box className="border-primary-900 border rounded-full self-end p-0.5">
                                <ImageSynced key={avatar + '_' + getRefresh()} uri={avatar} refresh={getRefresh()} sync={'/contact/media/' + avatar} isAvatar={true} size='sm' bg='white' />
                            </Box>
                            :
                            <Checkbox size='lg' value={task.id} isChecked={selected} onChange={onSelectLocal} aria-label={task.title} className="w-12 self-end text-primary-900">
                                <CheckboxIndicator className="w-9 h-9 mr-0 border-primary-900">
                                    <CheckboxIcon as={CheckIcon} className="w-8 h-8 bg-primary-900" />
                                </CheckboxIndicator>
                            </Checkbox>
                        :
                        <IconMC className={`absolute top-[-20px] right-0 text-4xl ${isDone ? 'text-ina-green' : 'text-primary-900'}`} name={isDone ? 'check-circle' : 'checkbox-blank-circle-outline'} />
                    }
                </BasicElement>
                {showProgress && task && task.step != -1 &&
                    <Progress value={100 * (task.step + 1) / task.steps.length} className={` absolute w-[88%] h-2 left-3 -top-1 border bg-primary-50 border-primary-300 `}>
                        <ProgressFilledTrack className="h-2" />
                    </Progress>
                }
                {icon && <IconM className="absolute top-0 right-2 ml-2 text-lg text-primary-900" name={icon} />}
                {task.studio && <IconM className={`absolute top-0 ${icon ? 'right-8' : 'right-2'} ml-2 text-lg text-primary-900`} name='desktop-windows' />}
            </Button>
            {showTimer && task.step > -1 && task.steps[task.step].type == 2 && <TimerDisplay taskid={task.id} />}
        </View>
    ) : <></>;
}

export default function WorkflowListElement({ navigation, taskid, showProgress, showTimer, onDelete, onPress, disabled, selected, onSelect, icon, avatar, isDone, info, changed, context }) {
    showProgress = showProgress == undefined ? true : showProgress
    const task = useSelector((state) => state.workflows[taskid] || state.deleted.find(task => task.id == taskid))
    const online = useSelector((state) => state.server.online)

    const { width: windowWidth } = useWindowDimensions()

    const translateX = useSharedValue(0)
    const startX = useSharedValue(0)

    const moveStyle = useAnimatedStyle(() => ({
        transform: [
            { translateX: translateX.value },
        ],
    }))

    const snapPoint = (value, velocity, points) => {
        'worklet';
        const point = value + 0.2 * (velocity / 5)
        const deltas = points.map((p) => Math.abs(point - p))
        const minDelta = Math.min.apply(null, deltas)
        return points.filter((p) => Math.abs(point - p) === minDelta)[0]
    }


   const swipeGesture =
       Gesture.Pan()
                .activeOffsetX([-8, 5])
                .failOffsetY([-30, 30])
                .onBegin(() => {startX.value = translateX.value})
                .onUpdate(
                    (event) => {
                        translateX.value = Math.min(0, startX.value + event.translationX)
                    })
                .onEnd(
                    (event) => {
                        const dest = snapPoint(
                            translateX.value,
                            event.velocityX,
                            [-windowWidth - 10, -windowWidth + 50, 0]
                        )
                        translateX.value = withSpring(dest, { velocity: event.velocityX })
                        if (dest < -windowWidth) {
                            runOnJS(onDelete)(taskid)
                            if (task?.shared) {
                                translateX.value = withSpring(0)
                            }
                        }
                    })

    const onPressShow = () => {
        switchScreen(navigation, 'ShowWorkflow2', { taskid: task.id, isLoading: false })
    }

  return onDelete ? (
        <GestureDetector gesture={swipeGesture}>
            <Animated.View style={moveStyle}>
                <HStack space='lg'>
                    <ButtonElement navigation={navigation} task={task} showProgress={showProgress} showTimer={false} onPress={onPress || onPressShow} disabled={disabled || (online && task && task.locked)} greyout={online && task && task.locked} selected={selected} onSelect={onSelect} icon={icon} replaceAvatar={avatar} isDone={isDone} info={info} changed={changed} context={context} />
                    <TouchableWithoutFeedback style={{ flex: 1, width: windowWidth + 20, justifyContent: 'center', backgroundColor: '#D60000' }}>
                        <IconM className="ml-1/3 text-4xl text-secondary-50" name='delete' />
                    </TouchableWithoutFeedback>
                </HStack>
            </Animated.View>
        </GestureDetector>
    ) : (
        <ButtonElement task={task} showProgress={showProgress} showTimer={showTimer} onPress={onPress || onPressShow} disabled={disabled || (online && task && task.locked)} greyout={online && task && task.locked} selected={selected} onSelect={onSelect} icon={icon} replaceAvatar={avatar} isDone={isDone} info={info} changed={changed} context={context} />
    )
}
